import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.938 6.5h.874c.711 0 1.313.602 1.313 1.313v7.875c0 .738-.602 1.312-1.312 1.312h-.876a1.296 1.296 0 0 1-1.312-1.312V7.812c0-.71.574-1.312 1.313-1.312m5.25 0h.874c.711 0 1.313.602 1.313 1.313v7.875c0 .738-.602 1.312-1.312 1.312h-.876a1.296 1.296 0 0 1-1.312-1.312V7.812c0-.71.574-1.312 1.313-1.312"
    }, null, -1)
  ]))]))
}
export default { render: render }